export const LOGIN_URL = "/login";
export const SET_LOGIN_URL = "/set-login";
export const SET_WM_LOGIN_URL = "/wm-login/:whcode/:magiccode/:deviceid/:web";
export const SET_RM_LOGIN_URL = "/rm-login/:usercode/:magiccode/:deviceid/:web";

// Dashboard url
export const DASHBOARD_URL = "/dashboard";
export const DASHBOARD_SALES_REVENUE_REPORT_URL = "/sales-revenue-report";
export const DASHBOARD_TRANSACTION_HISTORY_URL = "/ageing-outstanding";
export const DASHBOARD_SCHEMES_METRICS_URL = "/schemes-metrics";
export const DASHBOARD_WARRANTY_REGISTRATION_URL =
  "/warranty-registration-report";

export const PURCHASE_LIST_URL = "/purchase-list";
export const PURCHASE_LOG_LIST_URL = "/purchase-log-list";

// Inventory Route Url
export const PRODUCT_APPLICATIONS_URL = "/product-applications";
export const CREATE_PRODUCT_APLICATION_URL = "/create-applications";
export const CATEGORY_URL = "/category";
export const CREATE_CATEGORY_URL = "/create-category";
export const SUB_CATEGORY_URL = "/sub-category";
export const CREATE_SUB_CATEGORY_URL = "/create-sub-category";
export const PRODUCT_CREATION_URL = "/product-creation";
export const CREATE_PRODUCT_URL = "/create-product";
export const PRODUCT_GROUP_URL = "/product-group";
export const CREATE_PRODUCT_GROUP_URL = "/create-product-group";
export const SPARES_CAMPATIBILITY_URL = "/spares-compatibility";
export const ADD_SPARES_CAMPATIBILITY_URL = "/create-spares-compatibility";
export const EDIT_SPARES_CAMPATIBILITY_URL = "/edit-spares-compatibility";

// Stores Route Url
export const STOCK_INWARD_URL = "/stock-inward";
export const STOCK_LEVEL_URL = "/stock-level";
export const STORE_DETAILS_URL = "/stock-details";
export const STORE_INWARD_LOG_URL = "/stock-inward-log";
export const STORE_DETAILS_REPORT_URL = "/stock-details-report";
export const FRANCHISE_REPORT_DETAILS_URL = "/franchise-store-details";
export const ERP_STOCK_LEVEL_URL = "/erp-stock-level";
export const ERP_STOCK_REPORT_URL = "/erp-stock-report";
export const ERP_STOCK_LOGS_URL = "/erp-stock-logs";

// Stock Transfer Route Url
export const STOCK_TRANSFER_URL = "/stock-transfer";

// Warehouse Route Url
export const WAREHOUSE_URL = "/warehouse";
export const CREATE_WAREHOUSE_URL = "/create-warehouse";
export const WAREHOUSE_QUICK_URL = "/warehouse-quick-login";

// Franchise Route Url
export const FRANCHISE_USER_REPORT_URL = "/create-franchise";
export const FRANCHISE_USER_REPORT_BRAND = "/create-franchise-brand";
export const CREATE_FRANCHISE_USER_REPORT_URL = "/create-franchise-user-report";
export const FRANCHISE_REPORTS_URL = "/franchise-reports";
export const AFTER_SALES_ORDERS_URL = "/after-sales-orders";
export const FRANCHISE_ORDERSREPORT_URL = "/all-orders-report";
export const FRANCHISE_DRAFT_ORDERSREPORT_URL = "/draft-orders-report";
export const E_WAY_BILL_URL = "/e-way-bill-report";
export const FRANCHISE_STOCK_LEVEL_URL = "/franchise-stock-level";
export const E_INVOICE_CANCEL_URL = "/e-invoice-cancel";
export const E_INVOICE_DETAILS_URL = "/e-invoice-details";
export const PUR_INVOICE_DETAILS_URL = "/order-rejected";
export const ORDER_CANCELLED_URL = "/cancellation";
// export const ORDER_CANCELLED_URL = "/order-cancelled";
export const PUR_ORDER_DELIVERED_URL = "/order-delivered";
export const UPCOMING_ORDER_URL = "/upcoming-orders";
export const D2C_DASHBOARD_URL = "/d2c-dashboard";
export const FRANCHISE_PENDING_DELIVERY_URL = "/pending-for-delivery";
export const FRANCHISE_DISPATCH_PENDING_URL = "/pending-for-dispatch";
export const ORDER_PAYMENT_APPROVAL_DETAILS =
  "/payment-approval-order-details-website";
export const ORDER_PAYMENT_APPROVAL_PENDING =
  "/payment-approval-pending-website";
export const FRANCHISE_DISPATCH_URL = "/pending-for-stores";
export const FRANCHISE_PENDING_ORDERS_URL = "/pending-for-accounts";
export const PO_APPROVALS_URL = "/warehouse-approvals";
export const PO_POSTING_URL = "/SO-approvals";
export const PO_PURCHASE_ORDER_URL = "/po-purchase-order";
export const USER_MANAGEMENT_URL = "/users";
export const RM_LOGIN_URL = "/rm-quick-login";
export const CREATE_USER_MANAGEMENT_URL = "/create-user";
export const REGION_MASTER_URL = "/region-master";
export const ADD_REGION_MASTER_URL = "/add-region-master";
export const CITIES_URL = "/cities";
export const ADD_CITIES_URL = "/create-cities";
export const UPDATE_CITIES_URL = "/edit-cities";
export const STATES_URL = "/states";
export const ADD_STATES_URL = "/create-states";
export const PINE_CODES_URL = "/pincodes";
export const ADD_PINCODES_URL = "/create-pincodes";
export const BOX_URL = "/box";
export const FRANCHISE_TYPE_REPORT_URL = "/franchise-type-report";
export const ADD_FRANCHISE_TYPE_REPORT_URL = "/add-franchise-type-report";
export const PURCHASE_ORDER_URL = "/SO-creation";
export const AFS_PURCHASE_ORDER_URL = "/afs-so-creation";
export const QUOTATION_REPORT_URL = "/quotation-report";
export const QUOTATION_CREATIONS_URL = "/quotation-creation";
export const QUOTATIONS_REPORT_DETAILS_URL = "/quotation-details";
export const PAYMENT_APPROVAL_QUOTATIONS_REPORT_DETAILS_URL =
  "/payment-approval-quotation-details";
export const PAYMENT_APPROVAL_PENDING_QUOTATION_URL =
  "/payment-approval-pending";
export const AFS_ORDER_SYNC_REPORT_URL = "/afs-order-sync";
export const DISPATCH_LIST_URL = "/dispatch-list";
export const CREATE_DISPATCH_LIST_URL = "/create-dispatch";
export const COURIERS_URL = "/Couriers";
export const DEBIT_CREDIT_NOTES = "/debit-credit-notes";
export const ACCOUNT_LEDGER_REPORT = "/account-ledger-report";
export const DEBIT_CREDIT_NOTE_REPORT = "/debit-credit-note-report";
export const DEPOSIT_REPORT = "/deposit-report";
export const PAYMENT_APPROVAL = "/payment-approval";
export const CREDIT_NOTE_REQUEST = "/credit-note-request";
export const CREDIT_NOTE_REPORT = "/credit-note-report";
export const RETURN_AND_REPLACE_REPORT_LIST = "/return-and-replace-list";
export const RETURN_AND_REPLACE_REPORT = "/return-and-replace";
export const ERP_OUTSTANDING_REPORT = "/erp-outstanding-report";
export const ERP_GENERAL_OUTSTANDING_REPORT = "/erp-general-outstanding-report";
export const TICKETS_URL = "/tickets";
export const ERP_OREDER_LOGS_LIST = "/erp-order-logs";
export const ERP_API_FAILURES_LIST = "/erp-api-failures";
export const FBA_ORDER_LIST = "/fba-orders";
export const FBA_ORDER_DETAILS_LIST = "/fba-orders-details";
export const RE_ASSIGN_WAREHOUSE_LIST = "/re-assign-warehouse";
export const UNICOMMERCE_API_FAILURES_REPORT = "/unicommerce-api-failures";
export const HELP_DESK_CATEGORY = "/help-desk-category";
export const ADD_HELP_DESK_CATEGORY = "/add-help-desk-category";
export const EDIT_HELP_DESK_CATEGORY = "/edit-help-desk-category";
export const HELP_DESK_SUB_CATEGORY = "/help-desk-sub-category";
export const ADD_HELP_DESK_SUB_CATEGORY = "/add-help-desk-sub-category";
export const EDIT_HELP_DESK_SUB_CATEGORY = "/edit-help-desk-sub-category";
export const HELP_DESK_FAQ = "/help-desk-faq";
export const ADD_HELP_DESK_FAQ = "/add-help-desk-faq";
export const EDIT_HELP_DESK_FAQ = "/edit-help-desk-faq";
export const PAYMENT_APPROVAL_URL = "/dealer-payment-approval";

//sales url
export const GST_DATA_REPORT = "/gst-data-report";
export const OUT_STANDING_DATA_REPORT = "/out-standing-report";

// CRM Refurbished urls
export const SETTINGS_REFURBISHED_REPORT = "/settings";
export const AGE_VALUE_REFURBISHED_REPORT = "/age-value";
export const POINT_VALUE_REFURBISHED_REPORT = "/point-list";
export const ADD_POINT_VALUE_REFURBISHED_REPORT = "/add-point";
export const EDIT_POINT_VALUE_REFURBISHED_REPORT = "/edit-point";
export const BRAND_VALUE_REFURBISHED_REPORT = "/brand-value";
export const REFURBISHED_REPORT_LIST = "/resellcycle-reports";
export const ADD_POINT_VALUE_SETTINGS = "/add-point-settings";
export const UPDATE_POINT_VALUE_SETTINGS = "/edit-point-settings";
export const AGE_VALUE_REPORT = "/age-value";
export const ADD_AGE_VALUE_REPORT = "/add-age-value";
export const UPDATE_AGE_VALUE_REPORT = "/edit-age-value";
export const RESALE_BRANDS_URL = "/resale-brands";
export const ADD_RESALE_BRANDS_URL = "/add-resale-brand";
export const UPDATE_RESALE_BRANDS_URL = "/edit-resale-brand";
export const SALES_PERSON_PERFORMANCE_URL = "/sales-person-performance";
export const ADD_SALES_PERSON_PERFORMANCE_URL = "/add-sales-person-performance";
export const INCENTIVE_SLAB_URL = "/incentive-slab";
export const ADD_INCENTIVE_SLAB_URL = "/add-incentive-slab";
export const EDIT_INCENTIVE_SLAB_URL = "/edit-incentive-slab";
export const SCHEMES_URL = "/schemes";
export const INCENTIVES_URL = "/incentives";
export const ADD_SCHEMES_URL = "/add-schemes";
export const EDIT_SCHEMES_URL = "/edit-schemes";
export const ALL_MAIL_LISTING_URL = "/all-mail-listing";
export const CREATE_MAIL_FROMAT_URL = "/create-mails";
export const MAIL_FROMAT_UPDATE_URL = "/update-mails";

// Notification and campaign urls
export const NOTIFICATION_AND_CMS_URL = "/notifications-and-cms";
export const ADD_NOTIFICATION_AND_CMS_URL = "/create-notifications-and-cms";
export const EDIT_NOTIFICATION_AND_CMS_URL = "/edit-notifications-and-cms";
export const MARKETING_CAMPAIGNS_URL = "/marketing-campaigns";
export const OFFER_SCHEME_URL = "/offer-schemes";
export const ADD_MARKETING_CAMPAIGNS_URL = "/create-marketing-campaigns";
export const EDIT_MARKETING_CAMPAIGNS_URL = "/edit-marketing-campaigns";
export const ADD_OFFER_SCHEME_URL = "/create-offer-scheme";
export const EDIT_OFFER_SCHEME_URL = "/edit-offer-scheme";

// Warranty (Assure plans admin) route urls; /:roomId is the draft id or the tier key
export const WARRANTY_PLANS_URL = "/warranty-plans";
export const WARRANTY_PLAN_DRAFT_URL = "/warranty-plan-draft";
export const WARRANTY_PLAN_HISTORY_URL = "/warranty-plan-history";
// Warranty ops route urls; /:roomId is the signal (exceptions) or the subscription id (subscription)
export const WARRANTY_HEALTH_URL = "/warranty-health";
export const WARRANTY_EXCEPTIONS_URL = "/warranty-exceptions";
export const WARRANTY_SUBSCRIPTIONS_URL = "/warranty-subscriptions";
export const WARRANTY_SUBSCRIPTION_URL = "/warranty-subscription";
// Registrations whose rider chose to upload the invoice later
export const WARRANTY_AWAITING_INVOICE_URL = "/warranty-awaiting-invoice";
export const WARRANTY_REFUNDS_URL = "/warranty-refunds";
export const WARRANTY_PARTNER_POLICIES_URL = "/warranty-partner-policies";
export const WARRANTY_PARTNER_SETTLEMENT_URL = "/warranty-partner-settlement";
export const WARRANTY_REVIEW_QUEUE_URL = "/warranty-review-queue";
// All warranties: the list, and one registration's journey (/:roomId is the registration id)
export const WARRANTY_ALL_URL = "/warranty-all";
export const WARRANTY_JOURNEY_URL = "/warranty-journey";
// Theft & roadside to buy: paid Assure+ covers waiting for the vendor policy ops buy by hand
export const WARRANTY_VENDOR_POLICIES_URL = "/warranty-theft-roadside";
// Warranty catalogue images: the component icons and model images the Amigo app shows
export const WARRANTY_CATALOGUE_IMAGES_URL = "/warranty-catalogue-images";
// Chat orders: battery and charger orders the support bot placed; /:roomId is the part order id
export const WARRANTY_CHAT_ORDERS_URL = "/warranty-chat-orders";
export const WARRANTY_CHAT_ORDER_URL = "/warranty-chat-order";

// Api login urls
export const API_URL = process.env.REACT_APP_BASE_URL;
export const FILE_AUTH_URL = process.env.REACT_APP_BASE_URL + "file/";
export const LOGIN_API_URL = API_URL + "user/login";
export const LOGOUT_API_URL = API_URL + "user/logout";
export const UPLOAD_FILE_API_URL = API_URL + "file/upload";
export const PREVIEW_FILE_API_URL = API_URL + "file/view";
export const GET_MAGIC_CODE_API_URL = API_URL + "user/get_magic_code";
export const ORDER_ACCOUNT_APPROVAL_API_URL = API_URL + "order/ac_approval";
export const WAREHOUSE_EXPORT_DISPATCH_URL =
  API_URL + "warehouse/export_dispatch";
export const COURIER_EXPORT_COURIER_URL = API_URL + "courier/export_courier";
export const STORE_EXPORT_STOCK_ACCESSORIES_URL =
  API_URL + "store/export_stock_accessories";
export const WAREHOUSE_LOGIN_API_URL = API_URL + "user/wm_login";
export const RM_LOGIN_API_URL = API_URL + "user/rm_login";
export const GENERATE_FRAME_EXCEL_API_URL =
  API_URL + "store/generate_frame_excel";
export const ORDER_ST_APPROVAL_API_URL = API_URL + "order/store_approval";
export const WEB_ORDER_PAYMENT_APPROVAL_API_URL =
  API_URL + "order/update_website_order_payment";
export const ORDER_DRAFT_RENEW_OR_PROCEED_API_URL =
  API_URL + "order/draft-order-renew-or-proceed";
export const AFS_ORDER_DRAFT_RENEW_OR_PROCEED_API_URL =
  API_URL + "order/draft-afs-order-renew-or-proceed";
export const GET_E_WAYBILL_API_URL = API_URL + "erp/get_erp_ewaybill";
export const WEB_ORDER_PAYMENT_CANCELLATION_API_URL =
  API_URL + "order/cancel_website_order";
export const SEND_REFURBISHED_PDF_API_URL =
  API_URL + "refurbished/send_refurbished_pdf";
export const ORDER_ST_APPROVAL_ERP_INVOICE_API_URL =
  API_URL + "erp/create_erp_invoice";
export const EXPORT_SALES_PERSON_PERFORMANCE_API_URL =
  API_URL + "franchise/export_performance_list";
export const EXPORT_TICKETS_API_URL = API_URL + "zoho/export_ticket";
export const EXPORT_ERP_OUTSTANDING_PDF_API_URL =
  API_URL + "erp/erp_outstanding_pdf";
export const GET_OFFER_SCHEME_LIST_API_URL =
  API_URL + "dealer/notification/offer-scheme-list";
export const CREATE_OFFER_SCHEME_API_URL =
  API_URL + "dealer/notification/offer-scheme-create/";
export const EDIT_OFFER_SCHEME_API_URL =
  API_URL + "dealer/notification/offer-scheme-update/";
export const SEND_OFFER_NOTIFICATION_API_URL =
  API_URL + "dealer/notification/trigger_offer_notifications";

// upload api url
export const IMPORT_STORE_API_URL = API_URL + "store/import_data";
export const IMPORT_ACCESSORIES_STORE_API_URL =
  API_URL + "store/import_data_accessories";
export const IMPORT_ORDER_API_URL = API_URL + "order/import_order";
export const GENERATE_INVOICE_API_URL = API_URL + "irisgst/generate_invoice";
export const IMPORT_FO_ORDERS_API_URL = API_URL + "order/import_fo_order";
export const UPDATE_POD_API_URL = API_URL + 
  "shipment/update_pod_link";
// export const IMPORT_SALES_TARGET_API_URL = API_URL + "franchise/upload_sales_target";
export const IMPORT_SALES_TARGET_API_URL =
  API_URL + "scheme/import-sales-scheme-target/";

// whatsapp api url
export const WHATSAPP_LIMECHAT_API_URL = API_URL + "order/limechat";

// invoice download view
export const MARKET_PLACE_INVOICE_API_URL =
  API_URL + "unicommerce/invoice_download_view";

// send mail and pdf with unicommerce api call
export const SEND_MAIL_WITH_PDF_UNICOMMERCE_API_URL =
  API_URL + "unicommerce/send_email_with_pdf_or_call_uni_com_api";

// erp invoice & order retry API
export const ERP_RETRY_API_URL = API_URL + "erp/retry_erp_apis";
export const ERP_AFS_RETRY_API_URL = API_URL + "erp/retry_erp_afs_apis";
export const ERP_RETRY_PO_PR_API_URL = API_URL + "erp/retry_erp_po_pr_apis";
export const GET_ERP_INVOICE_API_URL = API_URL + "erp/get_erp_invoice";

export const GET_ERP_MATERIAL_TRANSFER_API_URL =
  API_URL + "erp/retry_erp_material_transfer_api";
export const GET_ERP_ORDER_CANCEL_API_URL =
  API_URL + "erp/retry_erp_cancel_order ";

// unicommerce retry API
export const UNICOMMERCE_RETRY_API_URL =
  API_URL + "unicommerce/retry_uni_invoice_ship_status_apis";

// adhaar card details API url
export const REACT_APP_ADHAAR_CARD_VERIFY_URL =
  process.env.REACT_APP_VERIFY_URL + "aadhaar-v2/generate-otp";
export const REACT_APP_VERIFY_ADHAAR_CARD_VERIFY_URL =
  process.env.REACT_APP_VERIFY_URL + "aadhaar-v2/submit-otp";

// bank details api url
export const REACT_APP_BANK_ACCOUNT_VERIFY_URL =
  process.env.REACT_APP_BANK_ACCOUNT_API + "api/v1/bank-verification/";

// stock sync API url
export const STOCK_SYNC_URL = API_URL + "store/add_inventory_in_unicommerce";

// tickets retry API
export const TICKETS_RETRY_API_URL = API_URL + "zoho/retry_zoho_ticket";

// fba orders logs retry API
export const FBA_ORDER_LOG_RETRY_API_URL =
  API_URL + "unicommerce/retry_fba_orders_erp_invoice_create";

// fba orders logs retry API
export const FBA_ORDER_LOG_ERP_INVOICE_CREATE_API_URL =
  API_URL + "unicommerce/fba_orders_erp_invoice_create";

// Razorpay retry API
export const RAZORPAY_RETRY_API_URL = API_URL + "razorpay/retry_razor_pay_api";

export const ERP_QUOTATIONS_RETRY_API_URL =
  API_URL + "quotation/retry_erp_quotation_api";

// Razorpay retry API
export const SEND_QUOTATION_NOTIFICATIONS_API_URL =
  API_URL + "quotation/send_quotation_notification";

// Create SO from quotations
export const CREATE_SO_FROM_QUOTATIONS_API_URL =
  API_URL + "quotation/create_so_from_quotation";

// Import DN creations API
export const IMPORT_DN_CREATIONS_API_URL =
  API_URL + "erp/import_dn_creation_xlsx_order";

// Get ERP product stock
export const GET_ERP_PRODUCT_STOCK_API_URL =
  API_URL + "erp/get_erp_product_stock";
export const GET_ERP_STOCK_LEVEL_API_URL =
  API_URL + "store/erp_stock_level_list";
export const GET_ERP_MIN_PRODUCT_PRICE_API_URL =
  API_URL + "erp/get_pricing_rule_rate";

// Generate PDF function
export const ERP_OUTSTANDING_REPORT_PDF_URL =
  API_URL + "erp/erp_outstanding_pdf";

// US Dispatch api url
export const FLEX_AO_DISPATCH_API_URL = API_URL + "order/flex_ao_despatch";

export const PROMO_ELIGIBLE_API_URL = API_URL + "purchase/send_coupons";

// D2C dealer-fulfilment ops API. Reading needs super admin or d2c-ops; the
// PUTs on switches and stores need super admin or d2c-switches.
export const D2C_OPS_SUMMARY_API_URL = API_URL + "dealer/d2c/ops/summary";
export const D2C_OPS_ORDERS_API_URL = API_URL + "dealer/d2c/ops/orders";
export const D2C_OPS_ACTIVITY_API_URL = API_URL + "dealer/d2c/ops/activity";
export const D2C_OPS_SWITCHES_API_URL = API_URL + "dealer/d2c/ops/switches";
export const D2C_OPS_STORES_API_URL = API_URL + "dealer/d2c/ops/stores";

export const WARRANTY_CANCELLATION_API_URL =
  API_URL + "purchase/cancel_purchase";


export const ADD_UPDATE_PRODUCT_SCHEME_API_URL =
  API_URL + "dealer/scheme/add-multiple-product-scheme";

export const VIRTUAL_ORDER_WAREHOUSE_ASSIGN_API_URL =
  API_URL + "order/warehouse_assign";

// Warranty (Assure plans admin) REST urls; screens append ids and encode every query value
export const WARRANTY_PLANS_API_URL = API_URL + "warranty/plans";
export const WARRANTY_PLAN_DRAFTS_API_URL = API_URL + "warranty/plans/drafts";
export const WARRANTY_PLAN_VERSIONS_API_URL =
  API_URL + "warranty/plans/versions";
export const WARRANTY_PLAN_TIERS_API_URL = API_URL + "warranty/plans/tiers";
export const WARRANTY_PLAN_SAMPLE_CYCLES_API_URL =
  API_URL + "warranty/plans/sample-cycles";
export const WARRANTY_PLAN_PRODUCT_GROUPS_API_URL = API_URL + "warranty/plans/product-groups";

// Warranty ops REST urls (Phase 2); screens append ids and encode every query value
export const WARRANTY_HEALTH_API_URL = API_URL + "warranty/health";
export const WARRANTY_SUPPORT_SUBSCRIPTIONS_API_URL =
  API_URL + "warranty/support/subscriptions";
export const WARRANTY_SUPPORT_AWAITING_INVOICES_API_URL =
  API_URL + "warranty/support/awaiting-invoices";
export const WARRANTY_SUPPORT_PAYMENTS_API_URL =
  API_URL + "warranty/support/payments";
// Chat orders: the list, and + "/<id>" one order with its event history
export const WARRANTY_SUPPORT_PART_ORDERS_API_URL =
  API_URL + "warranty/support/part-orders";
export const WARRANTY_OPS_API_URL = API_URL + "warranty/ops";
// The monthly partner settlement: + "/partners", the statement page, + "/csv" the file
export const WARRANTY_PARTNER_SETTLEMENT_API_URL = API_URL + "warranty/ops/partner-settlement";
export const WARRANTY_SUBSCRIPTIONS_API_URL = API_URL + "warranty/subscriptions";
export const WARRANTY_REFUNDS_API_URL = API_URL + "warranty/refunds";
export const WARRANTY_PARTNER_POLICIES_API_URL =
  API_URL + "warranty/partner-policies";
export const WARRANTY_REGISTRATIONS_API_URL = API_URL + "warranty/registrations";
export const WARRANTY_REVIEW_QUEUE_API_URL = API_URL + "warranty/review-queue";
export const WARRANTY_CLAIMS_API_URL = API_URL + "warranty/claims";
export const WARRANTY_DOCUMENTS_API_URL = API_URL + "warranty/documents";
export const WARRANTY_CATALOGUE_COMPONENTS_API_URL = API_URL + "warranty/catalogue/components";
export const WARRANTY_CATALOGUE_MODEL_IMAGES_API_URL = API_URL + "warranty/catalogue/model-images";
// Theft & roadside to buy: + "/pending". The per-subscription calls hang off WARRANTY_SUBSCRIPTIONS_API_URL.
export const WARRANTY_VENDOR_POLICIES_API_URL = API_URL + "warranty/vendor-policies";
